import { keywordGroupsQueryClient, keywordGroupsTransforms } from "app/services/keyword-groups";
import { swSettings } from "app/common/services/swSettings";

import { KEYWORD_MARKET_ANALYSIS_GROUP_SEARCH_TRENDS_STATE } from "../../consts";

export const buildDemandPageViewCustomData = async (toStateName: string, params: { [key: string]: string }) => {
    switch (toStateName) {
        case KEYWORD_MARKET_ANALYSIS_GROUP_SEARCH_TRENDS_STATE: {
            const { KW_list_type, KW_list_name, KW_list_num_keywords, compare_mode, num_of_entities } = params;
            return { KW_list_type, KW_list_name, KW_list_num_keywords, compare_mode, num_of_entities };
        }
        default: {
            const { keyword } = params;
            const keywordGroup = await keywordGroupsQueryClient.getGroupById(
                keywordGroupsTransforms.getGroupIdFromUrlParam(keyword),
            );
            if (!keywordGroup) {
                return {};
            }
            const { Keywords: keywords, Name: name, UserId: userID } = keywordGroup;
            const isSharedWithMe = String(swSettings.user.id) !== userID;
            return {
                KW_list_type: "Keyword list",
                KW_list_ID: params.keywordGroupId,
                KW_list_name: name,
                KW_list_num_keywords: keywords.length,
                KW_list_shared_with_me: isSharedWithMe,
                Clusters: params.showClusters === "true" ? "on" : "off",
            };
        }
    }
};
